import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGovernmentThinIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 682.6667 682.6667"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <clipPath id="a" clipPathUnits="userSpaceOnUse">
        <path d="M0 512h512V0H0Z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.6667)">
      <path
        d="m0 0 246.014-116.922h-492z"
        transform="translate(255.9858 501.4531)"
      />
      <path
        d="M0 0v-24.068c0-9.532-7.795-17.31-17.348-17.31h-414.643c-9.525 0-17.348 7.778-17.348 17.31V0"
        transform="translate(480.6553 334.3857)"
      />
      <path
        d="M0 0v-25.511c0-11.992-9.836-21.778-21.826-21.778h-54.141c-11.99 0-21.826 9.786-21.826 21.778V0"
        transform="translate(146.457 293.0078)"
      />
      <path
        d="M0 0v-25.511c0-11.992-9.808-21.778-21.826-21.778h-54.141c-11.99 0-21.798 9.786-21.798 21.778V0"
        transform="translate(304.8823 293.0078)"
      />
      <path
        d="M0 0v-25.511c0-11.992 9.808-21.778 21.798-21.778h54.169c11.99 0 21.798 9.786 21.798 21.778V0"
        transform="translate(365.543 293.0078)"
      />
      <path
        d="M0 0h201.114v24.068c0 9.532-7.823 17.31-17.347 17.31h-457.305c-9.553 0-17.348-7.778-17.348-17.31V0H-89.8"
        transform="translate(300.8857 10.5469)"
      />
      <path
        d="M0 0v25.511c0 11.992-9.808 21.778-21.826 21.778h-54.141c-11.99 0-21.826-9.786-21.826-21.778V0m256.218 0v25.511c0 11.992-9.807 21.778-21.798 21.778H82.458c-11.99 0-21.797-9.786-21.797-21.778V0m-219.086 0v25.511c0 11.992-9.836 21.778-21.826 21.778h-54.141c-11.99 0-21.826-9.786-21.826-21.778V0"
        transform="translate(304.8823 51.9248)"
      />
      <path d="M10 334.386h492v50.146H10Z" />
      <path
        d="M0 0v146.505m54.141 0V0"
        transform="translate(70.4902 99.2139)"
      />
      <path d="M0 0v-50.146" transform="translate(128.7695 384.5312)" />
      <path d="M0 0v-50.146" transform="translate(79.8159 384.5312)" />
      <path d="M0 0v-50.146" transform="translate(280.4766 384.5312)" />
      <path d="M0 0v-50.146" transform="translate(231.5234 384.5312)" />
      <path d="M0 0v-50.146" transform="translate(432.1558 384.5312)" />
      <path d="M0 0v-50.146" transform="translate(383.2021 384.5312)" />
      <path
        d="M0 0v146.505m54.141 0V0"
        transform="translate(228.9155 99.2139)"
      />
      <path
        d="M0 0v146.505m54.169 0V0"
        transform="translate(387.3408 99.2139)"
      />
      <path d="M0 0h-.057" transform="translate(256.0425 10.5469)" />
    </g>
  </svg>
);
export default SvgGovernmentThinIcon;
